export function getGlobalConfig() {
  return window.GLOBAL_INFO || {};
}
export const clientUrl = window.GLOBAL_INFO.wujiClientUrl || '/';
//# sourceMappingURL=config.js.map
